module.exports = "../static/media/SweetShort-Button.9762dcd4.png";